import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5071j6eb6g: FaireBrandEntity = {
  token: "b_5071j6eb6g",
  type: "brand",
  name: "NutraChamps",
  avatarUrl:
    "https://cdn.faire.com/fastly/28d8ebe5f42497b7a16f4e235f5248bc69cec3f53acd1d772d2aabc53371113e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6884b769c8a63c19cd430890f24a806c25093481c3bb1d292c6ec65adbc391c9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/28d8ebe5f42497b7a16f4e235f5248bc69cec3f53acd1d772d2aabc53371113e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6884b769c8a63c19cd430890f24a806c25093481c3bb1d292c6ec65adbc391c9.jpeg",
  location: "North York, ON, CAN",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 17,
  isInsider: true,
  description:
    "NutraChamps is a nutritional supplement company committed to helping people throughout their journey towards achieving optimal health, wellness, & longevity. Our mission is to create premium quality supplements using safe, naturally sourced, proven ingredients combined with the best methods available in nature and science.\n\nOur ultimate goal is to help people live healthier and happier lives, and that is why we research and craft only outstanding nutritional supplements. Whether you’re looking for products to help with energy, stress, digestion, heart health, weight management, or other important areas of health, NutraChamps is here to support you every step of the way.\n\nOne of our guiding beliefs here at NutraChamps is that there’s always a way  to improve. To put it simply - we’re obsessed with finding ways to do things better. We do this by taking what’s worked in nature for thousands of years and integrating it with the most cutting edge nutritional science available. Our love for the earth and natural medicine set us out on a quest to provide  the most beneficial ingredients inspired by nature and science. We firmly believe in nature’s ability to heal, but believing isn’t quite enough. Research-based science goes into each product we design, because researching and crafting effective products that actually work is our job.\n\nAre you ready to #ChampionYourLife?",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:26.759Z",
    importedBy: "entity-db-cli",
  },
};
